/**
 * -----------------------------------------------------------------------------------------------------------
 * Account module
 * -----------------------------------------------------------------------------------------------------------
 */
export const SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO'
export const REMOVE_ACCOUNT_INFO = 'REMOVE_ACCOUNT_INFO'

export const SET_LIST_LANGUAGE = 'SET_LIST_LANGUAGE'
export const SET_LIST_ICON = 'SET_LIST_ICON'
export const SET_ICON_GALLERIES = 'SET_ICON_GALLERIES'

export const SET_LIST_AGENCY = 'SET_LIST_AGENCY'
export const SET_AGENCY = 'SET_AGENCY'

export const SET_LIST_MANAGER = 'SET_LIST_MANAGER'
export const SET_MANAGER = 'SET_MANAGER'

export const SET_LIST_PRICING = 'SET_LIST_PRICING'
export const SET_LIST_CATEGORY = 'SET_LIST_CATEGORY'

export const SET_LIST_MESSAGE = 'SET_LIST_MESSAGE'
export const SET_MESSAGE_VERSION = 'SET_MESSAGE_VERSION'

export const SET_S3_CREDENTIALS = 'SET_S3_CREDENTIALS'
export const SET_S3_BUCKET = 'SET_S3_BUCKET'

export const SET_ACTIVE_PROJECT_NUMBER = 'SET_ACTIVE_PROJECT_NUMBER'
export const SET_INACTIVE_PROJECT_NUMBER = 'SET_INACTIVE_PROJECT_NUMBER'
export const SET_FIRST_AND_LAST_PROJECT = 'SET_FIRST_AND_LAST_PROJECT'

export const SET_LIST_EXAMPLE_PICTURE = 'SET_LIST_EXAMPLE_PICTURE'

export const SET_VARIANT = 'SET_VARIANT'
export const CHANGE_VARIANT_INVENTORY = 'CHANGE_VARIANT_INVENTORY'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js